import { getJson } from './client';

export interface SavingsBreakdown {
  /** PV→load × buy_price: vermeden grid-import (eigenverbruik-besparing) */
  pv_selfuse_eur: number;
  /** PV→grid × sell_price: PV-export opbrengst */
  pv_export_eur: number;
  /** Batterij-ontlading → grid × sell_price in uren zonder PV (arbitrage) */
  arbitrage_eur: number;
}

export interface SavingsTodayBreakdown extends SavingsBreakdown {
  /** Totaal vandaag: som van de drie componenten */
  total_eur: number;
}

export interface SavingsTotal {
  since_iso: string | null;
  until_iso: string | null;
  n_buckets: number;
  n_priced_buckets: number;
  total_pv_kwh: number;
  total_load_kwh: number;
  /** Totale verdiende waarde: pv_selfuse + pv_export + arbitrage */
  total_savings_eur: number;
  /**
   * Wachtrij #133: kalenderdagen tussen since_iso en until_iso. Het totaal
   * loopt vanaf de oudste bucket in state.db, en die verschilt per site.
   * Ontbreekt op Pi's van vóór deze wijziging.
   */
  span_days?: number | null;
  /** Dagen die de 5-minutenbuckets werkelijk dekken (gaten tellen niet mee). */
  days_covered?: number | null;
  /** Uitsplitsing per component (cumulatief) */
  breakdown?: SavingsBreakdown;
  /** Vandaag-uitsplitsing */
  today?: SavingsTodayBreakdown;
  /**
   * Cycle #137/#139 + #399 W1: server kon de savings niet (vers) berekenen —
   * meestal SQLite page-corruptie op het snapshots-leespad. De respons is dan
   * 200 (geen 500), maar de bedragen zijn NIET vers. Zie `stale`.
   */
  degraded?: boolean;
  /** Korte machine-leesbare reden, bv. `sqlite_database_error: ...`. */
  degraded_reason?: string;
  /**
   * Cycle #399 W1: true ⇒ de bedragen zijn de laatst-bekende-GOEDE waarden
   * (bruikbaar, maar verouderd sinds `stale_since_iso`). False bij degraded
   * ⇒ er was geen last-known-good; de nullen zijn géén meting en mogen niet
   * als bedrag getoond worden.
   */
  stale?: boolean;
  /** Wanneer de getoonde stale waarden voor het laatst vers waren. */
  stale_since_iso?: string | null;
}

export function fetchSavingsTotal(): Promise<SavingsTotal> {
  return getJson<SavingsTotal>('/api/savings/total');
}
